export enum MessageModalsType {
    SET_MESSAGE_MODAL_DATA = "SET_MESSAGE_MODAL_DATA",
    CLEAR_MESSAGE_MODAL_DATA = "CLEAR_MESSAGE_MODAL_DATA",
}